import React from 'react';
import PropTypes from 'prop-types';
import { Button, LinearProgress, Typography } from '@mui/material';
import FilePicker from './FilePicker';

const UploadView = ({
  header,
  onFormSubmit,
  selectedFileName,
  onFileSelection,
  isLoading,
  showUploadButton,
  subHeader,
  errorMsg,
  uploadDisabled,
}) => (
  <div className="UploadView">
    <div>{header && <div>{header}</div>}</div>
    <br />
    <div>{subHeader && <div>{subHeader}</div>}</div>
    <form>
      <br />
      <FilePicker
        disabled={uploadDisabled}
        selectedFileName={selectedFileName}
        onFileSelection={onFileSelection}
      />
      <br />
      {isLoading && (
        <div>
          <LinearProgress color="secondary" />
        </div>
      )}
      {!isLoading && showUploadButton && (
        <div>
          <Button
            color="primary"
            variant="contained"
            style={{ verticalAlign: 'middle' }}
            onClick={onFormSubmit}
          >
            Upload
          </Button>
        </div>
      )}
      <br />
      {errorMsg && (
        <div className="UploadView-error">
          <Typography color="error">{errorMsg}</Typography>
        </div>
      )}
    </form>
  </div>
);

UploadView.defaultProps = {
  header: null,
  subHeader: null,
  errorMsg: '',
  uploadDisabled: false,
};

UploadView.propTypes = {
  onFormSubmit: PropTypes.func.isRequired,
  onFileSelection: PropTypes.func.isRequired,
  selectedFileName: PropTypes.string.isRequired,
  header: PropTypes.string,
  isLoading: PropTypes.bool.isRequired,
  showUploadButton: PropTypes.bool.isRequired,
  subHeader: PropTypes.string,
  errorMsg: PropTypes.string,
  uploadDisabled: PropTypes.bool,
};

export default UploadView;
